




































































































import Vue from "vue";
import EditCheckBox from "@/components/end_parts/EditCheckBox.vue";
import EditSelectionBox from "@/components/end_parts/EditSelectionBox.vue";
import EditText from "@/components/end_parts/EditText.vue";

export default Vue.extend({
  components: {
    EditCheckBox,
    EditSelectionBox,
    EditText,
  },
  props: {
    keyParents: {
      type: String,
      default: String,
    },
    outputCsvKey: {
      type: String,
      default: String,
    },
    outputCsvJson: {
      type: Object,
      default: Object,
    },
    outputCsvTransform: {
      type: Object,
      default: Object,
    },
    inputThirdHeader: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      JsonParam: Object,
      columnName: {
        "background-color": "#BAD3FF",
        padding: "10px",
        margin: "0px -15px",
        "border-top": "solid 1px #DDDDDD",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      columnCenter: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
      column: {
        padding: "5px",
        margin: "0px -15px",
        "border-right": "solid 1px #DDDDDD",
        "border-bottom": "solid 1px #DDDDDD",
        "border-left": "solid 1px #DDDDDD",
      },
    };
  },
  watch: {
    outputCsvJson: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    outputCsvTransform: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.reload();
  },
  methods: {
    reload() {
      this.JsonParam = this.outputCsvJson[this.outputCsvKey];
    },
  },
});
